import React, { useEffect, useRef } from "react";
import { TCText } from "../../components/TCText/TCText";
import { Strings } from "../../utils/strings";
import { Colors } from "../../utils/colors";
import { StaticBackdropModal } from "../../components/modal/staticBackdropModal/StaticBackdropModal";
import { observer } from "mobx-react-lite";
import {
  useCourtBookingStore,
  useLoginStore,
  useOTPStore,
} from "../../stores/StoreContext";
import { Button } from "../../components/button/Button";
import { OverlayLoadingIndicator } from "../../components/overlayLoadingIndicator/OverlayLoadingIndicator";
import { ResendOTPAgain } from "../../components/resendOTPAgain/ResendOTPAgain";
import { OTPSuccessVerificationMsg } from "../../components/otpSuccessVerificationMsg/OTPSuccessVerificationMsg";
import { isIOS } from "react-device-detect";
import { Navigate } from "react-router-dom";
import { useCourtBooking } from "../../context/courtBookingContext";

type props = {};

export const OTPVerification: React.FC<props> = observer(() => {
  const loginStore = useLoginStore();
  const inputRef = useRef<HTMLInputElement>(null); // Create a ref for the input element
  const otpStore = useOTPStore();
  const { setIsAuthenticated } = useCourtBooking();

  useEffect(() => {
    return () => {
      otpStore.reset();
    };
  }, []);

  useEffect(() => {
    if (otpStore.isOTPVerified) {
      setIsAuthenticated(true);
      <Navigate to="/match-list" />;
    }
  }, [otpStore.isOTPVerified]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "90%",
        height: "100vh",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "450px",
        overflow: "hidden", // Disable scrolling
        paddingBottom: isIOS ? 30 : 0,
      }}
    >
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          flex: 5,
        }}
      >
        <TCText
          style={{ fontWeight: 600, fontSize: 25, color: "black" }}
          value={Strings.OTP_VERIFICATION}
        />
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <TCText
            style={{
              fontWeight: 400,
              fontSize: 16,
              color: Colors.grey,
              marginTop: 10,
              display: "inline",
            }}
            value="Code has been sent to your mobile number associated with the account and to your email "
          />
          <TCText
            style={{
              fontWeight: 700,
              fontSize: 16,
              color: Colors.grey,
              display: "inline",
            }}
            value={loginStore.email ?? ""}
          />
        </div>
        <div style={{ width: "100%", marginTop: 50 }}>
          <TCText
            style={{
              fontSize: 15,
              color: Colors.grey,
              marginBottom: 5,
              fontWeight: 400,
              marginLeft: 2,
            }}
            value="Enter code"
          />
          <input
            type="number"
            value={otpStore.otp}
            disabled={otpStore.isLoading}
            onChange={otpStore.handleOTPChange}
            // onKeyDown={otpStore.handleKeyPress}
            ref={inputRef}
            required
            style={{
              width: "100%",
              padding: isIOS ? "14px 16px" : "12px 16px",
              borderRadius: 16,
              border: `1px solid ${Colors.lightGreyBackground}`,
              backgroundColor: "white",
              fontSize: 20,
              outline: "none",
              color: Colors.green,
              textAlign: "center",
              fontWeight: 700,
              fontFamily: "Poppins",
              // Fix for iOS numeric inputs
              WebkitAppearance: isIOS ? "none" : undefined,
            }}
            inputMode={isIOS ? "numeric" : undefined}
          />
          <Button
            text={Strings.VERIFY}
            onPress={() => {
              // otpStore.verifyOTPCode();
            }}
            disabled={otpStore.isLoading || otpStore.otp?.length !== 4}
            btnStyle={{
              width: "100%",
              backgroundColor: Colors.darkBrown,
              marginTop: 30,
              height: 52,
            }}
            textStyle={{ color: "white" }}
          />
          {otpStore.isSuccess ? <OTPSuccessVerificationMsg /> : null}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          alignItems: "flex-end",
          display: "flex",
          paddingBottom: 40,
        }}
      >
        <ResendOTPAgain />
      </div>
      <StaticBackdropModal
        children={otpStore.modalData?.children}
        title={otpStore.modalData?.title}
        handleClose={
          otpStore.modalData?.onClose ??
          (() => (otpStore.modalData = undefined))
        }
        show={!!otpStore.modalData}
        headerIcon={otpStore.modalData?.headerIcon}
        btnText={otpStore.modalData?.btnText}
        handleOpen={otpStore.modalData?.onAccept}
      />
      <OverlayLoadingIndicator
        loading={otpStore.isLoading}
        text="Verifying OTP..."
      />
    </div>
  );
});
